// extracted by mini-css-extract-plugin
export var circle = "_7m-1";
export var exitConfirmationModal = "_7m-5";
export var iframe = "_7m-0";
export var offline = "_7m-3";
export var online = "_7m-2";
export var workstationSelectError = "_7m-4";